"use strict";

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@lsg/utils");

var React = __importStar(require("react"));

var CSSPrefix_1 = require("../../../base/CSSPrefix");

var Outliers;

(function (Outliers) {
  Outliers["PERCENT_100"] = "lsg--layoutcontainer__percent100";
  Outliers["PERCENT_50"] = "lsg--layoutcontainer__percent50";
  Outliers["PERCENT_25"] = "lsg--layoutcontainer__percent25";
  Outliers["PERCENT_10"] = "lsg--layoutcontainer__percent10";
  Outliers["SECTION_MARGIN"] = "lsg--layoutcontainer__sectionMargin";
  Outliers["HALF_SECTION_MARGIN"] = "lsg--layoutcontainer__halfSectionMargin";
  Outliers["DOUBLE_SECTION_MARGIN"] = "lsg--layoutcontainer__doubleSectionMargin";
  Outliers["CONTAINER_MARGIN"] = "lsg--layoutcontainer__containerMargin";
})(Outliers || (Outliers = {}));

var Placements;

(function (Placements) {
  Placements["FOREGROUND"] = "lsg--layoutcontainer__foreground";
  Placements["BACKGROUND"] = "lsg--layoutcontainer__background";
})(Placements || (Placements = {}));

var Aligns;

(function (Aligns) {
  Aligns["LEFT"] = "lsg--layoutcontainer__left";
  Aligns["RIGHT"] = "lsg--layoutcontainer__right";
  Aligns["CENTER"] = "lsg--layoutcontainer__center";
})(Aligns || (Aligns = {}));

exports.LayoutContainer = function (_a) {
  var id = _a.id,
      className = _a.className,
      children = _a.children,
      outlierLeft = _a.outlierLeft,
      outlierRight = _a.outlierRight,
      outlierTop = _a.outlierTop,
      outlierBottom = _a.outlierBottom,
      placement = _a.placement,
      align = _a.align,
      displayXsAsBlock = _a.displayXsAsBlock;
  return React.createElement("div", {
    id: id,
    className: utils_1.DomUtils.cleanupClassNames([CSSPrefix_1.lsgPre + "layoutcontainer", className, outlierTop && CSSPrefix_1.prefixEnumClassNames(outlierTop) + "-top", outlierRight && CSSPrefix_1.prefixEnumClassNames(outlierRight) + "-right", outlierBottom && CSSPrefix_1.prefixEnumClassNames(outlierBottom) + "-bottom", outlierLeft && CSSPrefix_1.prefixEnumClassNames(outlierLeft) + "-left", CSSPrefix_1.prefixEnumClassNames(placement), CSSPrefix_1.prefixEnumClassNames(align), displayXsAsBlock && CSSPrefix_1.lsgPre + "layoutcontainer__xs-block"])
  }, align ? React.createElement("div", {
    className: CSSPrefix_1.lsgPre + "layoutcontainer-inner"
  }, children) : children);
};

exports.LayoutContainer.Outliers = Outliers;
exports.LayoutContainer.Placements = Placements;
exports.LayoutContainer.Aligns = Aligns;
exports.LayoutContainer.displayName = "LayoutContainer";